import xw from 'xwind';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Container } from '@/components/layout';
import { ContentType } from '@/common/constants/ContentTypes';
import SocialShare from '../../widgets/SocialShare/SocialShare';
import { Reactions } from '../../widgets';

export const AvatarWrapperDesktop = styled.div`
  ${xw`hidden sm:flex sm:flex-col`}

  gap: 0.625rem;
  grid-area: avatar;
`;

export const SocialShareDesktop = styled(SocialShare)`
  ${xw` sm:flex sm:flex-col gap-6 self-center items-center`}
  margin-left: 115px;
  margin-bottom: 30px;
  grid-area: social;

  @media (min-width: 640px) {
    margin-bottom: 0;
    position: sticky;
    top: 240px;
  }
`;

export const ReactionsSection = styled(Reactions)`
  grid-area: reactions;
`;

export const ContainerBlogPageStyled = styled(Container)`
  @media (max-width: 640px) {
    max-width: unset;
    margin: 0;
    padding: 0;
  }
`;

export const ContainerWrapper = styled.section<{ contentType: ContentType }>(
  xw`w-full sm:p-5 pt-0 grid sm:py-14 justify-center`,

  ({ contentType }) => css`
    grid-template:
      'image image image' auto
      '. social .' auto
      'tldr tldr tldr' auto
      '. collapse-btn .' auto
      '. content .' auto
      '. ext-link .' auto
      '. reactions .' auto
      'comments comments comments' auto
      'groups groups groups' auto
      'whatis whatis whatis' auto/ 20px 1fr 20px;

    @media (min-width: 640px) {
      grid-template:
        'image image image image social social social' auto
        'tldr tldr tldr tldr tldr . .' minmax(75px, auto)
        '. . . collapse-btn . . .' auto
        'content content content content content content .' auto
        '. ext-link ext-link ext-link . . .' auto
        '. . . reactions . . .' auto
        'comments comments comments comments comments comments .' auto
        'groups groups groups groups groups groups .' auto
        'whatis whatis whatis whatis whatis whatis .' auto / 20px 75px 24px 2fr 20px 24px
        ${contentType === ContentType.PRODUCTS ? 'minmax(200px,1fr)' : '75px'};
      gap: 0 28px;
    }
  `,
);
